var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-photo-placeholder"},[_c('span',{staticClass:"material-icons"},[_vm._v(" no_photography ")])])
}]

export { render, staticRenderFns }